import { h } from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import style from './style.less';
import {connect} from 'react-redux'
import {TimeSlotsCard} from 'components/partials'
import {Button, Container, Form, Row, Col, I18n} from 'components/elements'
import {AppointmentFilters} from 'components/groups'
import {PatientSelect} from 'components/partials'
import {times} from 'lib/helpers'
import {ProcessTimeSlots,pile} from 'lib/helpers'
import {ServiceRegionActions, AvailabilityActions, ShiftActions, TimeSlotActions, SelectedTimeSlotActions, FilterActions} from 'actions'
import dayjs from 'dayjs'
import _ from 'lodash'
import store from 'reducers'
import { filter } from 'core-js/fn/array';

@Form
@connect((state)=>({
	...state
}))
export default class TimeSlots extends WidgetComponent {
	constructor(){
        super()
        this.state = {
            processing: true,
            outOfSlots: {},
            serviceRegionIDs: []
        }
        this.proceed = this.proceed.bind(this)
        this.getTimeSlots = this.getTimeSlots.bind(this)
        this.getAdminTimeSlots = this.getAdminTimeSlots.bind(this)
        this.isTimeSlotInRange = this.isTimeSlotInRange.bind(this)
        this.updateDate = this.updateDate.bind(this)
        this.isAllInfoGathered = this.isAllInfoGathered.bind(this)
        this.handleTimeSlotSelect = this.handleTimeSlotSelect.bind(this)
        this.handlePrevDates = this.handlePrevDates.bind(this)
        this.handleNextDates = this.handleNextDates.bind(this)
		this.handleSkipToNext = this.handleSkipToNext.bind(this)
        this.handleMobileBackToAppointment = this.handleMobileBackToAppointment.bind(this)
        this.handleFilters = this.handleFilters.bind(this)
        this.handlePatientSelect = this.handlePatientSelect.bind(this)
    } 
    
    componentWillReceiveProps(newProps){
        if(_.difference(Object.keys(newProps.selectedPatients), Object.keys(this.props.selectedPatients)).length > 0){
            if(newProps.filters.patientCount == Object.keys(newProps.selectedPatients).length && newProps.selectedTimeSlot.id){
                this.proceed()
            } else if(this.hasRestrictions){
                FilterActions.set({
                    ...newProps.filters,
                    availabilitiesReceived: []
                })
                AvailabilityActions.clear()
                TimeSlotActions.set([])

                this.getTimeSlots(Object.values(newProps.selectedPatients || {}))
            }
        }
    }

    componentWillMount(){
        super.componentWillMount()
        let _outOfSlots = {}
        this.administrators.forEach((admin)=>{
            _outOfSlots[admin.id] = false
        })

        if(Object.keys(this.props.serviceRegions).length > 0){
            this.setState({
                loadingRegions: true,
                processing: true
            })
            ServiceRegionActions.fetch({
                organizationID: this.organization.id,
                accountID: this.props.session.accountID
            })
            .then((res)=>{
                this.setState({
                    outOfSlots: _outOfSlots,
                    serviceRegionIDs: res.data.map((serviceRegion)=>serviceRegion.id),
                    loadingRegions: false
                })
                
                this.getTimeSlots()
            })
        } else {
            this.setState({
                outOfSlots: _outOfSlots
            })
            
            this.getTimeSlots()
        }
    }

    proceed(){
        super.componentDidSubmit()
    }

	getTimeSlots(patients) {
        let availabilities = this.availabilities
        this.setState({
            processing: true
        })

        if(!patients){
            patients = Object.values(this.props.selectedPatients || {})
        }

        if(this.hasRestrictions && patients.length == 0){
            TimeSlotActions.set([])
            this.setState({
                processing: false
            })
            return
        }
        let startDate = this.startDate.startOf('day')
        let thisDay_week = startDate.clone().startOf('week').format("MM/DD/YYYY")
        let nextDay_week = startDate.clone().add(1,'day').startOf('week').format("MM/DD/YYYY")

        let availabilitiesReceived = (this.props.filters || {}).availabilitiesReceived || []
        let startingAt, endingAt

        if(!availabilitiesReceived.includes(thisDay_week)){
            startingAt = dayjs(thisDay_week).startOf('day').format()
            endingAt = dayjs(thisDay_week).endOf('week').format()
            availabilitiesReceived.push(thisDay_week)
        }
        if(!availabilitiesReceived.includes(nextDay_week)){
            if(!startingAt){
                startingAt = dayjs(nextDay_week).startOf('day').format()
            }
            endingAt = dayjs(nextDay_week).endOf('week').format()
            availabilitiesReceived.push(nextDay_week)
        }

        if(!startingAt){
            let serviceRegionIDs
            if(Object.keys(this.props.serviceRegions).length > 0){
                serviceRegionIDs = this.state.serviceRegionIDs
            } 
            TimeSlotActions.set(
                ProcessTimeSlots.all({
                    startingAt: startDate.format("MM/DD/YYYY"),
                    data: availabilities, 
                    shifts: this.props.shifts,
                    widgetAvailability: this.organization.widgetAvailability,
                    appointmentType: this.props.appointmentTypes[this.props.filters.appointmentTypeID],
                    patientCount: this.props.filters.patientCount,
                    administrators: this.props.administrators,
                    serviceRegionIDs,
                    patients
                })
            )

            this.setState({
                processing: false
            })
        } else {
            pile({},{
                availabilities: AvailabilityActions.fetch({
                    organizationID: this.organization.id,
                    appointmentTypeID: this.props.filters.appointmentTypeID,
                    startingAt,
                    endingAt,
                    accountID: this.props.session.accountID
                }),
                shifts: ShiftActions.fetch({
                    organizationID: this.organization.id,
                    startingAt,
                    endingAt,
                    active: true
                })
            }).then((response)=>{
                if(this.state.processingTimeout){
                    clearTimeout(this.state.processingTimeout)
                }
                this.setState({
                    processing: true,
                    processingTimeout: setTimeout(()=>{
                        this.setState({
                            processing: false
                        })
                    },300)
                })

                const _data = [...response.availabilities.data]
                availabilities = availabilities.concat(_data)

                let data = {}
                for(let item of _data){
                    data[item.id] = item
                }

                AvailabilityActions.appendMany(data)

                FilterActions.set({
                    ...this.props.filters,
                    availabilitiesReceived
                })

                let serviceRegionIDs
                if(Object.keys(this.props.serviceRegions).length > 0){
                    serviceRegionIDs = this.state.serviceRegionIDs
                } 
                TimeSlotActions.set(
                    ProcessTimeSlots.all({
                        startingAt: startDate.format("MM/DD/YYYY"),
                        data: availabilities, 
                        shifts: this.props.shifts,
                        widgetAvailability: this.organization.widgetAvailability,
                        appointmentType: this.props.appointmentTypes[this.props.filters.appointmentTypeID],
                        patientCount: this.props.filters.patientCount,
                        administrators: this.props.administrators,
                        serviceRegionIDs,
                        patients
                    })
                )
                this.setState({
                    processing: false
                })
            })
        }
    }

    get shouldShowPatients(){
        if(this.hasRestrictions){
            return !!this.appointmentType.id
        } else {
            return this.isTimeSlotSelected()
        }
    }

    get shouldShowAppointments(){
        if(this.hasRestrictions){
            return this.props.filters.patientCount == Object.keys(this.props.selectedPatients).length
        } else {
            return !!this.appointmentType.id
        }
    }


    isTimeSlotSelected(){
        return !!(this.props.selectedTimeSlot || {}).id
    }

    isAllInfoGathered(){
        return this.isTimeSlotSelected() && this.props.filters.patientCount == Object.keys(this.props.selectedPatients).length
    }

    updateDate(date){
        let _outOfSlots = {...this.state.outOfSlots}
        Object.keys(_outOfSlots).forEach((key)=>{_outOfSlots[key] = false})
        this.setState({
            outOfSlots: _outOfSlots
        })

        let data = this.props.filters
        data.startDate = dayjs(date).format("MM/DD/YYYY")
        delete data.date

        this.setState({
            startDate: data.startDate
        })

        this.getTimeSlots()
    }
     
    get timeSlots(){
        return this.props.timeSlots
    }

    get condensedTimeSlots(){
        let timeSlots = {}
        let adminTimeSlots =  this.timeSlots
        Object.keys(adminTimeSlots).forEach((adminKey)=>{
            if(this.props.administrators[adminKey] && this.props.administrators[adminKey].provider && this.props.administrators[adminKey].appointmentTypeIDs.includes(this.props.filters.appointmentTypeID)){
                Object.keys(adminTimeSlots[adminKey]).forEach((key)=>{
                    let timeSlot = adminTimeSlots[adminKey][key]
                    let splitKey = key.split("--")
                    let tempKey = `${splitKey[1]}--${splitKey[2]}`
                    if(this.isTimeSlotInRange(timeSlot) && !timeSlots[tempKey]){
                        timeSlots[tempKey] = timeSlot
                    }
                })
            }
        }) 

        return Object.values(timeSlots)
    }

    get widgetSettings(){
        return (this.organization || {}).widgetSettings || {}
    }

    get startDate(){
        return dayjs(this.props.filters.startDate || '')
    }

    get availabilities(){
        return Object.entries(this.props.availabilities || {}).map(([, _])=> _ )
    }

    get patients(){
        return Object.values(this.props.patients || {})
    }

	get administrators(){
        return Object.values(this.props.administrators || {})
        .filter((admin)=>{
            let appointmentTypeMatch = (!this.props.filters.appointmentTypeID || admin.appointmentTypeIDs.includes(this.props.filters.appointmentTypeID))
            let patientCountAllowed = this.props.filters.patientCount <= (admin.administratorOptions.maxPatientsPerVisit || 1)
            if(Object.keys(this.props.serviceRegions).length > 0){
                let inRegion = _.intersection(
                    this.state.serviceRegionIDs, 
                    admin.serviceRegions
                ).length > 0
                if(!inRegion) return false
            }
            if(appointmentTypeMatch && patientCountAllowed){
                return true
            }
            return false
        })
        .sort((a,b)=>{
            if(a.lastName > b.lastName) return 1
            if(a.lastName < b.lastName) return -1
            if(a.firstName > b.firstName) return 1
            if(a.firstName < b.firstName) return -1
            return 0
        })
    }

    get appointmentTypes(){
        return Object.values(this.props.appointmentTypes || {}).filter((appType)=>{
            if(appType.userType && ((!(this.props.session || {}).accessToken && appType.userType == 'returning') || ((this.props.session || {}).accessToken && appType.userType == 'new'))){
                return false
            }
            let maxPatients = 1
            if(appType.durations){
                maxPatients = appType.durations.split(',').length 
            }
            if(!this.props.filters.patientCount || this.props.filters.patientCount <= maxPatients){
                return true
            }
            return false
        })
    }

    get appointmentType(){
        return this.props.appointmentTypes[this.props.filters.appointmentTypeID] || {}
    }

    get hasRestrictions(){
        return (this.appointmentType.rules || []).length > 0
    }

    get genders(){
		return Object.values(this.props.genders || {}).map((_)=>({
            name: _.name,
			value: _.id
		}))
    }

    get promptText(){
        if(!this.props.filters.appointmentTypeID){
            return <I18n>selectAnAppointmentType</I18n>
        }
        if(this.hasRestrictions){
            return this.shouldShowAppointments ? <I18n>selectYourAppointment</I18n> : <I18n>selectYourPatients</I18n> 
        } else {
            return this.shouldShowPatients ? <I18n>selectYourPatients</I18n> : <I18n>selectYourAppointment</I18n> 
        }
    }

    get organization(){
        return this.props.organization || {}
    }
    
    getAdminTimeSlots(administrator){
        return Object.values(this.props.timeSlots[administrator.id] || {})
    }

    isTimeSlotInRange(timeSlot){
        let weekStart = this.startDate
        let weekEnd = weekStart.clone().add(1,"week")
        let startsAt = dayjs(timeSlot.startsAt)
        return (startsAt.isSame(weekStart) || startsAt.isAfter(weekStart)) && (startsAt.isSame(weekEnd) || startsAt.isBefore(weekEnd))
    }

    handleTimeSlotSelect(e){
        e.preventDefault()
        let administratorID = e.target.id.split('--')[0]
        let timeSlot = this.props.timeSlots[administratorID][e.target.id]
        SelectedTimeSlotActions.set(timeSlot)

        if(this.props.filters.patientCount == Object.keys(this.props.selectedPatients).length){
            this.proceed()
        }
    }

    handlePrevDates(e){
        e.preventDefault()
        this.updateDate(this.startDate.subtract(1,"days"))
    }

    handleNextDates(e){
        e.preventDefault()
        this.updateDate(this.startDate.add(1,"days"))
    }

    handleSkipToNext(administrator){
        let filterDate = dayjs((this.props.filters || {}).startDate)
        if(filterDate.isAfter(dayjs().add(6,'months'))){
            return false
        }
        if(filterDate.isBefore(dayjs())){
            filterDate = dayjs()
        }
        let appointmentTypeID = (this.props.filters.appointmentTypeID || "")
        let appointmentType = this.props.appointmentTypes[appointmentTypeID]
        let duration = appointmentType.durations.split(',')[this.props.filters.patientCount - 1]
        AvailabilityActions.fetch({
            organizationID: this.organization.id,
            findNext: true,
            startingAt: filterDate.format(),
            administratorID: administrator.id,
            duration
        })
        .then((response)=>{
            let _outOfSlots = {...this.state.outOfSlots}
            if(response.data[0]){
                this.updateDate(dayjs(response.data[0].startsAt).format("MM/DD/YYYY"))
                _outOfSlots[administrator.id] = false
            } else {
                _outOfSlots[administrator.id] = true
            }
            
            this.setState({
                outOfSlots: _outOfSlots
            })
        })
    }

    handleFilters(data){
        if(this.state.processingTimeout){
            clearTimeout(this.state.processingTimeout)
        }
        FilterActions.set({
            ...this.props.filters,
            ...data,
            availabilitiesReceived: []
        })
        AvailabilityActions.clear()
        TimeSlotActions.set([])

        this.setState({
            processing: true,
            processingTimeout: setTimeout(()=>{
                this.updateDate(data.startDate)
                this.setState({
                    processing: false
                })
            },300)
        })

        SelectedTimeSlotActions.set({})
    }

    handleMobileBackToAppointment(){
        SelectedTimeSlotActions.set({})
    }

    handlePatientSelect(){
        if(this.hasRestrictions){
            FilterActions.set({
                ...this.props.filters,
                availabilitiesReceived: []
            })
            AvailabilityActions.set({})
            TimeSlotActions.set([])
        }
    }

	render() {
        const {Form, InputDark, SelectDark, FormData} = this.props
        let patientStyle = [style.noPadding,style.patientContainer]
        if(!this.shouldShowPatients){ 
            patientStyle.push(style.faded);
        } 
        let administratorStyle = []
        if(!this.shouldShowAppointments){
            administratorStyle.push(style.faded);
        }
        if(this.isTimeSlotSelected()){ 
            administratorStyle.push(style.mobileFaded);
        }
		return (
			<div>
                <Row>
                    <Col span={{sm: 24}}>
                        <AppointmentFilters
                            hideSubmit={true}
                            onChange={this.handleFilters}
                            PatientCountFilters={{
                                    required: true,
                                    initialValue: this.props.filters.patientCount
                                }}
                            appointmentTypeFilters={{
                                    required: true,
                                    data: this.appointmentTypes,
                                    initialValue: this.props.filters.appointmentTypeID
                                }}
                            dateFilters={{
                                    required: true,
                                    initialValue: this.props.filters.startDate
                                }}
                        />
                    </Col>
                </Row>
                <Row class={style.centered}>
                    <Col span={{sm: 24, md:11}}>
                        {this.isAllInfoGathered()? 
                            ''
                        :
                            <div>
                                {this.isTimeSlotSelected() &&
                                    <div onClick={this.handleMobileBackToAppointment} class={style.mobileBack}><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
                                }
                                <div class={style.flowPrompt}>
                                    {this.promptText}
                                </div>
                            </div>
                        } 
                    </Col>
                    <div class={administratorStyle.join(' ')}>
                        <Col span={{sm: 1, md:2}} class={style.leftArrow} onClick={this.handlePrevDates}>
                            {dayjs().format("MM/DD/YYYY") != this.startDate.format("MM/DD/YYYY") &&
                                <div><i class="fa fa-chevron-left" aria-hidden="true"></i></div> 
                            }
                        </Col>
                        {times(2).map((i)=>{
                            let day = this.startDate.clone().add(i,"days").format("dddd")
                            let date = {
                                d: this.startDate.clone().add(i,"days").format("D"),
                                mmm: this.startDate.clone().add(i,"days").format("MMM")
                            }
                            return(
                                <Col span={{sm: 9, md: 5}} class={style.date}>
                                    <Row class={style.day}><I18n>{day.toLowerCase()}</I18n></Row>
                                    <Row><I18n>{date.mmm.toLowerCase()}</I18n> {date.d}</Row>
                                </Col>
                            )
                        })}
                        <Col span={{sm: 1, md: 1}} class={style.rightArrow} onClick={this.handleNextDates}>
                            <div><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
                        </Col>
                    </div> 
                </Row>
                <Row>
                    <Col span={{ sm: 24, md: 6 }} class={patientStyle.join(' ')}>
                        <PatientSelect onPatientSelect={this.handlePatientSelect}/>
                    </Col>
                    {this.widgetSettings.condenseAdministrators &&
                        <Col span={{sm: 24,md: 6}}>
                            <div></div>
                        </Col>
                    }
                    <Col span={{sm: 24,md: this.widgetSettings.condenseAdministrators? 12 : 18}} class={style.noPadding}>
                        <Row class={administratorStyle.join(' ')}>
                            {this.administrators.length == 0 ? (
                                this.state.loadingRegions ? (
                                    <div class={style.serviceRegionSpinner}>
                                        <i class={`fa fa-spinner fa-spin`} aria-hidden="true"></i>
                                    </div>
                                ) : (
                                    <div style={{
                                        position: 'relative',
                                        width: '100%'
                                    }}>
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: '20px',
                                            width: '800px',
                                            margin: '0 auto',
                                            paddingTop: '80px'
                                        }}>
                                            <I18n>noBooking</I18n>
                                        </div>
                                    </div>
                                )
                            ):(
                            this.widgetSettings.condenseAdministrators ?
                                <TimeSlotsCard 
                                    condensedAdministrators={true}
                                    processing={this.state.processing}
                                    startDate={this.startDate}
                                    timeSlots={this.condensedTimeSlots}
                                    onSelect={this.handleTimeSlotSelect}
                                    selectedTimeSlot={this.props.selectedTimeSlot}
                                    appointmentTypes={this.props.appointmentTypes}
                                    filters={this.props.filters}
                                    organization={this.props.organization}
                                    waitLists={this.props.waitLists}
                                    session={this.props.session}
                                />
                            :
                                this.administrators.map((administrator, i)=>{
                                    let timeSlots = this.getAdminTimeSlots(administrator).filter((timeSlot)=> this.isTimeSlotInRange(timeSlot))
                                    return (
                                        <TimeSlotsCard 
                                            {...administrator}
                                            processing={this.state.processing}
                                            startDate={this.startDate}
                                            timeSlots={timeSlots}
                                            onSelect={this.handleTimeSlotSelect}
                                            selectedTimeSlot={this.props.selectedTimeSlot}
                                            handleSkipToNext={this.handleSkipToNext.bind(null,administrator)}
                                            filters={this.props.filters}
                                            appointmentTypes={this.props.appointmentTypes}
                                            outOfSlots={this.state.outOfSlots[administrator.id]}
                                            organization={this.props.organization}
                                            waitLists={this.props.waitLists}
                                            session={this.props.session}
                                        />
                                    )
                                })
                            )}
                        </Row>
                    </Col>
                </Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/templates/TimeSlots/index.js